<template>
  <div>
    <h4 class="mb-5 grey--text">
      {{ $t('appointment.statusTable.details') }}
    </h4>

    <v-row dense>
      <v-col cols="6" md="4">
        <h6 class="text-uppercase grey--text">
          {{ $t('appointment.label.privateArea') }}
        </h6>
        <p :class="dense ? 'caption' : 'body-2'">
          {{
            item.private_area_meters
              ? `${item.private_area_meters}${$t(
                  'appointment.label.squareMetersSymbol'
                )}`
              : '---'
          }}
        </p>
      </v-col>
      <v-col cols="6" md="4">
        <h6 class="text-uppercase grey--text">
          {{ $t('appointment.label.totalArea') }}
        </h6>
        <p :class="dense ? 'caption' : 'body-2'">
          {{
            item.square_meters
              ? `${item.square_meters}${$t(
                  'appointment.label.squareMetersSymbol'
                )}`
              : '---'
          }}
        </p>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <h6 class="text-uppercase grey--text">
          {{ $t('appointment.formCreate.labels.furnished.label') }}
        </h6>
        <p :class="dense ? 'caption' : 'body-2'">
          {{ furnishingLabel }}
        </p>
      </v-col>
      <v-col>
        <h6 class="text-uppercase grey--text">
          {{ $t('appointment.formCreate.labels.trousseau.label') }}
        </h6>
        <p :class="dense ? 'caption' : 'body-2'">
          {{
            item.trousseau !== undefined && item.trousseau !== null
              ? $t(
                  `appointment.formCreate.labels.trousseau.${item.trousseau}`
                )
              : '---'
          }}
        </p>
      </v-col>
      <v-col>
        <h6 class="text-uppercase grey--text">
          {{ $t('appointment.formCreate.labels.painting.label') }}
        </h6>
        <p :class="dense ? 'caption' : 'body-2'">
          {{
            item.painting_status
              ? $t(
                  `appointment.formCreate.labels.painting.${item.painting_status.toLowerCase()}`
                )
              : '---'
          }}
        </p>
      </v-col>
    </v-row>
    <div v-if="item.description">
      <h6 class="text-uppercase grey--text">
        {{ $t('appointment.label.description') }}
      </h6>
      <span :class="dense ? 'caption' : 'body-2'">
        {{ item.description }}
      </span>
    </div>
  </div>
</template>

<script>
import { furnishingKey } from '@/util/furnishing'

export default {
  name: 'AppointmentRealtiesDetails',

  props: {
    dense: {
      type: Boolean,
      default: false,
    },

    item: {
      type: Object,
      required: true,
    }
  },

  computed: {
    furnishingLabel() {
      const key = furnishingKey(this.item)
      return key ? this.$t(key) : '---'
    },
  },
}
</script>
